import React from 'react'
import Form from '../UI/Form'
import avatar from '../../img/footer/avatar@3x.png'
import loveIcon from '../../img/footer/icon-love@3x.png'

const Footer = () => (
  <footer className='footer bg-dark'>
    <div className='container'>
      <h2 className='text-white text-center'>
        &ldquo;
        I would use this dating app so much, not gonna lie.
        &ldquo;
      </h2>
      <div className='avatar flex items-center text-white justify-center'>
        <img className='avatar-icon mr-2' src={avatar} alt='avatar' />
        <a href='https://twitter.com/swyx/status/1349267007665958913'><u>@swyx</u></a>
      </div>
      <Form />
      <div className='text-white flex items-center justify-center'>
        Made with
        {' '}
        <img className='love-icon' src={loveIcon} alt='love' />
        {' '}
        by
        {' '}
        <a href='https://twitter.com/altalogy' className='ml-1'><u>Altalogy</u></a>
      </div>
      <div className='text-white flex items-center justify-center'>
        <a className='text-gray-500' href='https://altalogy.com/contact'><u>hire us</u></a>
      </div>
    </div>
  </footer>
)

export default Footer
